import React, {useState, useEffect} from 'react'
import {useParams} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {Notification, Loading, Input} from '@haravan/react-components'
import {StoreRepository} from '../../../../../repositories'
import {closePopup} from '../../../../../components/popup/popup_slice'
import * as HrvComponents from "@haravan/react-components";
import {T} from '../../../../../components'

export function TransformOrg() {
    const dispatch = useDispatch()
    const {shopId} = useParams()
    const [toOrgId, setToOrgId] = useState(null)
    const [loading, setLoading] = useState(false);
    const [inspect, setInspect] = useState(false);
    const [storeInfo, setStoreInfo] = useState(null);

    useEffect(() => {
        inspect && fetchStore();
    }, [inspect]);

    const fetchStore = async () => {
        if (!toOrgId || !parseInt(toOrgId) || toOrgId === shopId) {
            Notification.error({message: 'Vui lòng nhập OrgId để chuyển đổi', duration: 2})
            setInspect(false);
            return
        }
        const response = await StoreRepository.GetStore(toOrgId);
        if (!response || !response.data) {
            setInspect(false);
            Notification.error({message: 'Không tìm thấy cửa hàng cần chuyển đổi', duration: 2})
            return;
        }
        setTimeout(() => setStoreInfo(response.data), 500);
    };

    const onTransform = async () => {
        setLoading(true);
        if (!toOrgId) {
            Notification.error({message: 'Vui lòng chọn cửa hàng để chuyển đổi', duration: 2})
            return
        }

        try {
            const rs = await StoreRepository.TransformOrgData(parseInt(shopId),parseInt(toOrgId));
            if (rs?.data) Notification.success({message: 'Đã chuyển đổi cửa hàng thành công', duration: 2})
            dispatch(closePopup());
        } catch (error) {
            Notification.error({message: 'Đã xảy ra lỗi trong quá trình chuyển đổi', duration: 2});
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className='shop-user'>
            {!inspect ? <>
                    <div className='p5'>
                        <div className="lable-input">OrgId</div>
                        <Input value={toOrgId} onChange={setToOrgId} placeholder={'Nhập OrgId'}/>
                    </div>
                    <div className='shop-user-btn'>
                        <HrvComponents.Button status="default" onClick={() => dispatch(closePopup())}>
                            Hủy
                        </HrvComponents.Button>
                        <HrvComponents.Button status="primary" loading={loading} onClick={() => setInspect(true)}>
                            Xác nhận
                        </HrvComponents.Button>
                    </div>
                </> :
                <>
                    {storeInfo ? <>
                            <div className='p5'>
                                <span>Bạn đang tiến hành chuyển đổi sang  <b>{storeInfo?.id} - {storeInfo?.name}</b></span>
                            </div>
                            <div className='shop-user-btn'>
                                <HrvComponents.Button status="default" onClick={() => dispatch(closePopup())}>
                                    Hủy
                                </HrvComponents.Button>
                                <HrvComponents.Button status="danger" loading={loading} onClick={onTransform}>
                                    Đồng ý
                                </HrvComponents.Button>
                            </div>
                        </>
                        : <div className='pd-t-20 pd-b-20'><Loading className='hrv-loading-btn' size='icon'/></div>
                    }
                </>}
        </div>
    )
}